import React from "react";
import { Route, Navigate, useLocation } from "react-router-dom";
import { LoginPage, SignupPage } from "features/auth";
import Logout from "shared/auth/utils/Logout";
import MobileRedirect from "shared/utils/MobileRedirect";
import { ROUTE_PATHS } from "app/config/routePaths";

type PublicRoutesProps = {
  isMobileDevice: boolean;
};

const MobileSignupRedirect = () => {
  const location = useLocation();
  return <Navigate to={`${ROUTE_PATHS.mobileSignup}${location.search}${location.hash}`} replace />;
};

/**
 * Public, unauthenticated top-level routes (login, signup, logout, root).
 *
 * Returned as a React fragment so it can be embedded directly inside the
 * top-level `<Routes>` element in `app/routes/index.tsx`.
 */
export const publicRoutes = ({
  isMobileDevice,
}: PublicRoutesProps): React.ReactElement => (
  <>
    <Route
      path={ROUTE_PATHS.root}
      element={<Navigate to={ROUTE_PATHS.login} />}
    />
    <Route path={ROUTE_PATHS.logout} element={<Logout />} />
    <Route
      path={ROUTE_PATHS.login}
      element={
        isMobileDevice ? (
          <MobileRedirect
            to={`${ROUTE_PATHS.mobileLogin}${window.location.hash}`}
          />
        ) : (
          <LoginPage />
        )
      }
    />
    <Route
      path={ROUTE_PATHS.signup}
      element={
        isMobileDevice ? (
          <MobileSignupRedirect />
        ) : (
          <SignupPage />
        )
      }
    />
  </>
);

export default publicRoutes;
